module.exports = __webpack_public_path__ + "img/home_answer_bg.7ce848e9.png";